import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatButton } from 'components/blocks-components';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';

type CatButtonProps = ComponentProps<typeof CatButton> & { ariaLabel?: string };
export const AddEquipmentButton: FC<PropsWithChildren<CatButtonProps>> = ({
  children,
  ...buttonProps
}) => {
  const { addEquipmentDrawer, setLastActiveElement } = useMyEquipmentDrawer();
  const handleAddEquipmentDrawer = () => {
    setLastActiveElement(`[data-testid='add-button']`);
    addEquipmentDrawer.openDrawer();
  };

  return (
    <CatButton
      variant="primary"
      fullWidth
      onClick={handleAddEquipmentDrawer}
      data-testid="add-button"
      {...buttonProps}
    >
      {children}
    </CatButton>
  );
};
